/**
 * @ mention command — opens MentionPopover when the caret sits immediately after
 * an `@` typed at the start of a word.
 *
 * Detection runs in registerUpdateListener (after Lexical commits the inserted
 * character, so the DOM caret rect is reliable). A fingerprint of the trigger
 * site (nodeKey + offset + text length) prevents the popover from re-opening
 * after dismissal while the same `@` remains in place. All state and event
 * wiring lives in MentionStore.
 */

import { realmPlugin, addComposerChild$, useCellValue, readOnly$ } from '@mdxeditor/editor'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import { useMarkdownStore } from '../../MarkdownStore'
import MentionPopover from '../../popover/MentionPopover'
import DateSubmenuPopover from '../../popover/DateSubmenuPopover'
import MentionStore from './MentionStore'

const MentionComponent = observer(function MentionComponent() {
   const [editor] = useLexicalComposerContext()
   const isReadOnly = useCellValue(readOnly$)
   const markdownStore = useMarkdownStore()

   const mentionStore = useStore(sp => new MentionStore(sp), { editor, markdownStore })

   if (isReadOnly) return null

   return (
      <>
         {mentionStore.open && !mentionStore.datePicker && (
            <MentionPopover
               anchor={mentionStore.open.anchor}
               query={mentionStore.open.query}
               team={mentionStore.team}
               clientUsers={mentionStore.clientUsers}
               clientOrgName={mentionStore.clientOrgName}
               onSelect={mentionStore.handleSelect}
               onClose={mentionStore.close}
            />
         )}
         {mentionStore.datePicker && (
            <DateSubmenuPopover
               anchor={mentionStore.datePicker}
               onSelect={mentionStore.handleDatePicked}
               onClose={mentionStore.close}
            />
         )}
      </>
   )
})

export const mentionPlugin = realmPlugin({
   init(realm) {
      realm.pub(addComposerChild$, MentionComponent)
   },
})
